import ReactConfetti from 'react-confetti'

interface ConfettiProps {
  /** Height of the burst area in pixels. */
  height?: number
  /** Width of the burst area in pixels. */
  width?: number
  /** Whether the confetti animation plays. */
  shouldRun?: boolean
}

/**
 * Shared confetti burst for insights-v2 celebratory beats. Fires once from the center and
 * settles (`recycle={false}`). Decorative only — `aria-hidden`. Callers size it via
 * `width`/`height` (measure the container with `useContainerDimensions`).
 */
export const Confetti = ({ height = 0, width = 0, shouldRun = false }: ConfettiProps) => {
  return (
    <ReactConfetti
      aria-hidden={true}
      colors={['#3F9FEB', '#C331B6', '#30C434', '#F1CE31', '#EE3B7C']}
      confettiSource={{
        x: width / 2,
        y: height / 2,
        w: 20,
        h: 20,
      }}
      gravity={0.05}
      height={height}
      initialVelocityX={7}
      initialVelocityY={8}
      numberOfPieces={200}
      recycle={false}
      run={shouldRun}
      style={{ inset: 'auto' }}
      width={width}
    />
  )
}

export default Confetti
